module.exports = __webpack_public_path__ + "static/parade-2020-house53-fce59e2622e8bed2a5900d0bb754a631.jpg";